(function ( $ ) {

	$.fn.herovideo = function () {
		var $elem = $( this ),
			videoData = $elem.data( 'video' ),
			videoId,
			startedPlaying = false;

		var init = function () {

				if ( videoData && ! CAF.UTILS.areWeMobile() ) {

					$( window ).on( 'load', function () {

						loadYtJs();

						videoId = CAF.UTILS.youTubeGetID( videoData );
						if ( videoId ) {
							$elem.data( 'parsedId', videoId )
						}

						// $elem.prepend( videoData );
						// $elem.find( '.hero__image' ).remove();
					} );
				}
			},
			loadYtJs = function () {
				if ( typeof CAF == 'undefined' ) {
					CAF = {};
				}

				if ( typeof CAF.youtubeJsLoaded == 'undefined' || CAF.youtubeJsLoaded != true ) {
					var tag = document.createElement( 'script' );

					tag.src = "//www.youtube.com/iframe_api";
					var firstScriptTag = document.getElementsByTagName( 'script' )[ 0 ];
					firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );

					if ( typeof window.onYouTubeIframeAPIReady == 'undefined' ) {
						window.onYouTubeIframeAPIReady = function () {
							CAF.youtubeJsLoaded = true;

							setupAndPlayBg();
						}
					}

				}
			},
			setupAndPlayBg = function () {

				var idUniqueness = Date.now() / 1000 | 0,
					idToUse = 'yt-frame--' + idUniqueness,
					$currImage = $elem.find( '.hero__image' ),
					$currPlayer;

				if ( $currImage.length > 0 ) {
					$currPlayer = $( '<div id="' + idToUse + '" />' ).insertBefore( $currImage );
				} else {
					$currPlayer = $elem.prepend( '<div id="' + idToUse + '" />' );
				}

				if ( typeof CAF.players == 'undefined' ) {
					CAF.players = {};
				}

				// ref: https://developers.google.com/youtube/player_parameters
				CAF.players[ idToUse ] = new YT.Player(
					idToUse, {
						videoId    : videoId,
						playerVars : {
							autohide       : 2,
							autoplay       : 0,
							controls       : 0,
							loop           : 1,
							modestbranding : 1,
							rel            : 0,
							showinfo       : 0,
							playlist       : videoId // This one looks weird, but it goes with the loop param
						},
						events     : {
							'onReady'       : playSilently,
							'onStateChange' : fadeOutImage
						}
					} );
			},
			playSilently = function ( event ) {

				event.target.setVolume( 0 );
				event.target.playVideo();

			},
		// Even when you ask the API to start playing,
		// there might be a delay while it starts buffering
		// So as not to show any "loading" indicator,
		// we wait for it to actually start playing
			fadeOutImage = function ( event ) {

				if ( event.data == 1 && startedPlaying == false ) {
					var $currImage = $elem.find( '.hero__image' );

					if ( $currImage.length > 0 ) {

						$currImage.fadeOut( 'slow', function () {
							//$( this ).remove();
						} );
					}

					startedPlaying = true;
				}
			};


		init();
		return this;
	};

}( jQuery ));